import { createContext } from 'react'
import { IScriptDetailsContext } from '../interfaces'

export const StoreFrontScriptManagerDetailsContext = createContext<IScriptDetailsContext>({
  script: null,
  isLoading: false,
  isOperationLoading: false,
  updateScript: (data: any, scriptId: string, setError: any) => {},
  createScript: (data: any, setError: any) => {},
  hasWritePermission: false,
})
